window.sq.addToCart = function (item, store) {
  setTimeout(() => {
    var buttons = document.querySelectorAll(".add-item-jx");
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var buttonText = button.querySelector(".add-item-jx-text");
        var originalText = buttonText.innerText;
        buttonText.innerText = "Added to Cart";

        // Revert the button text after 3 seconds
        setTimeout(function () {
          buttonText.innerText = originalText;
        }, 3000);

        // Show a notification (optional)
      });
    });
  }, 500);
  return true;
};

// set Varaint on select option
setVariant = function (e) {
  let sparqCard = e.closest(".sparq-card");
  let variantPriceSelector = sparqCard.querySelector(`.sq-variant-${e.value}`);
  let priceSelector = sparqCard.querySelector(".sq-sy-price .sq-price");
  let comparePriceSelector = sparqCard.querySelector(
    ".sq-sy-price .sq-compare-price"
  );
  let price = parseFloat(
    variantPriceSelector.querySelector("span").textContent
  );
  let compare_at_price = variantPriceSelector.querySelectorAll("span")[1]
    .textContent
    ? parseFloat(variantPriceSelector.querySelectorAll("span")[1].textContent)
    : 0;
  let allHrefLinks = sparqCard.querySelectorAll("a");
  allHrefLinks.forEach((j) => {
    let hrefLink = j.getAttribute("href");
    if (hrefLink) {
      if (hrefLink.includes("variant")) {
        hrefLink = j.setAttribute(
          "href",
          hrefLink.replace(/variant=\d+/, `variant=${e.value}`)
        );
      } else {
        j.setAttribute("href", (hrefLink += "?variant=" + e.value));
      }
    }
  });

  if (compare_at_price > price) {
    if (priceSelector)
      priceSelector.innerHTML = price.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
  } else {
    console.log(price);
    if (priceSelector)
      priceSelector.innerHTML = price.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
  }

  // add to cart button change variant id
  setVariantIdInAddtoCart(sparqCard, e.value);
};

window.sq.isSearchPage = function () {
  if (window.location.href.includes("/search")) return true;
  return false;
};

window.sq.onData = (searchResults) => {
  const fetchData = searchResults.results.map((r) => {
    return fetch("/products/" + r.handle + "?view=sparq&v=1")
      .then((res) => res.text())
      .then((txt) => {
        const d = JSON.parse(txt);
        r.price = d.product.price;
        r.compare_at_price = d.product.compare_at_price;
        r.image = d.product.image;
        r.inventory_quantity = d.product.inventory_quantity;
        r.variants = d.product.variants;
        changePrice(r);
        hideVariantOption(r);
        const sparqCard = document.querySelector(`.sparq-card[product-handle="${r.handle}"]`);
if (sparqCard) {
  const select = sparqCard.querySelector(".sq-variant-selection select");

  if (select && select.value) {
    setVariantIdInAddtoCart(sparqCard, select.value);
  } else if (r.variants && r.variants.length) {
    const firstInStock = r.variants.find(v => Number(v.inventory_quantity) > 0);
    setVariantIdInAddtoCart(sparqCard, (firstInStock || r.variants[0]).id);
  }
}
      })
      .catch((e) => {
        console.error(`Failed to fetch data for ${r.handle}: ${e}`);
      });
  });

  return searchResults.results;
};

function modifyUrl(url) {
  const index = url.lastIndexOf(".png");
  if (index !== -1) {
    // Insert 'x300' before '.png'
    return url.slice(0, index) + "_300x" + url.slice(index);
  }
  // If '.png' is not found, return the original URL
  return url;
}

function changePrice(item) {
  const sparqCard = document.querySelector(
    `.sparq-card[product-handle="${item.handle}"]`
  );

  const img = sparqCard.querySelector(".sq-sy-image img");
  const price = sparqCard.querySelector(".sq-price");
  const comparePrice = sparqCard.querySelector(".sq-compare-price");
  const sqSave = sparqCard.querySelector(".sq-save");
  const notLoyalityTag = sparqCard.querySelector(".not-loyalty-applicable");
  const inStock = sparqCard.querySelector(".product-inventory");
  const outOfStockTag = sparqCard.querySelector(".flash.sold-out");
  const addToCartBtnWrapper = sparqCard.querySelector(
    ".sq-add-to-cart-wrapper"
  );

  item.compare_at_price = parseFloat(item.compare_at_price);
  item.price = parseFloat(item.price);
  if (item.variants.length > 1) {
  setVariantPrices(item.variants, sparqCard);

  setTimeout(() => {
    const select = sparqCard.querySelector("select");
    if (select && select.options.length) {
      select.value = select.options[0].value;
      setVariant(select);
    }
  }, 0);
}
  if (price) {
    price.classList.add("loaded");
    price.innerHTML = item.price.toLocaleString("en-US", {
      style: "currency",
      currency:
        Shopify.currency.active == "CAD" ? "USD" : Shopify.currency.active,
    });
  }

  if (comparePrice) {
    comparePrice.classList.add("loaded");
    comparePrice.innerHTML = item.compare_at_price.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  if (item.image) img.src = modifyUrl(item.image);

  if (inStock) {
    if (item.inventory_quantity > 0) {
        let displayQuantity = item.inventory_quantity;
        inStock.innerHTML = `<p>In Stock: ${displayQuantity}</p>`;

        if (addToCartBtnWrapper) {
            addToCartBtnWrapper.querySelector(".add-item-jx-text").innerText = "Add to Cart";
            addToCartBtnWrapper
                .querySelector("button.add-item-jx")
                .removeAttribute("disabled");
        }
    } else {
        if (outOfStockTag) outOfStockTag.style.display = "block";
        inStock.innerHTML = `<p style="color: red;">Out of Stock</p>`;

        if (addToCartBtnWrapper) {
            addToCartBtnWrapper.querySelector(".add-item-jx-text").innerText = "Sold out";
            addToCartBtnWrapper
                .querySelector("button.add-item-jx")
                .setAttribute("disabled", true);
        }
    }
}

}

function setVariantPrices(variants, sparqCard) {
  variants.forEach((v) => {
    let variantPriceSelector = sparqCard.querySelector(`.sq-variant-${v.id}`);
    if(variantPriceSelector){
      variantPriceSelector.querySelectorAll("span")[0].innerHTML = v.price / 100;
      variantPriceSelector.querySelectorAll("span")[1].innerHTML =
      v.compare_at_price / 100;
    }
  });
}

function setVariantIdInAddtoCart(sparqCard, id) {
  if (!sparqCard || !id) return;

  let idInput = sparqCard.querySelector(`[name="id"]`);
  if (idInput) idInput.setAttribute("value", id);

  let addToCartButtons = sparqCard.querySelectorAll(`[data-vrid]`);
  addToCartButtons.forEach((btn) => {
    btn.setAttribute("data-vrid", id);
    btn.setAttribute("data-id", id);
    btn.setAttribute("data-variant-id", id);
  });
}

setTimeout(() => {
  // Select the first button with the class 'filter-by filterMobile'
  let btnFilterMobile = document.querySelectorAll(
    "button.filter-by.filterMobile"
  );
  if (btnFilterMobile.length)
    btnFilterMobile[0].onclick = function () {
      // Find the element with the class 'sparq-mobile-filterby'
      const targetElement = document.querySelector(".sparq-mobile-filterby");

      if (targetElement) {
        // Simulate a click on the target element
        targetElement.click();
      } else {
        console.error("Element with class .sparq-mobile-filterby not found");
      }
    };
}, 300);

function hideVariantOption(item) {
  //   const sparqCard = document.querySelector(
  //     `.sparq-card[product-handle="${item.handle}"]`
  //   );
  //   const selectElement = sparqCard.querySelector("select");
  //   item.variants.
}

document.addEventListener("click",e=>{
  const buttons = document.querySelectorAll(".btn.btn-dark.btn-outline.btn-rounded.quick-view");
  buttons.forEach(i=>{
    if(i.contains(e.target)) {
      setTimeout(()=>{
        let qv = document.querySelector("#ProductSection-main-product-qv");
        let summary = qv.querySelector(".summary");
        let contentSummary = qv.querySelector(".content-summary");
        contentSummary.style.maxHeight = (summary.clientHeight - 20) + "px";
      },1000);
    }
  })
})
